import ToneAlert from "@/components/ui/ToneAlert";
import { MESSAGE } from "@/constants/message";

interface WeightAutoAdjustedAlertProps {
  /** Advanced normalization mode renders the red (generate-blocking) variant;
   * simple mode renders the orange review reminder. */
  isAdvancedMode: boolean;
  className?: string;
  "data-testid"?: string;
}

const WeightAutoAdjustedAlert = ({
  isAdvancedMode,
  className,
  ...rest
}: WeightAutoAdjustedAlertProps) => {
  return (
    <ToneAlert
      tone={isAdvancedMode ? "error" : "warning"}
      variant="compact"
      className={className}
      iconTestId="weight-auto-adjusted-icon"
      {...rest}
    >
      {isAdvancedMode
        ? MESSAGE.DATA_WEIGHT_AUTO_ADJUSTED.ADVANCED
        : MESSAGE.DATA_WEIGHT_AUTO_ADJUSTED.SIMPLE}
    </ToneAlert>
  );
};

export default WeightAutoAdjustedAlert;
